export class CustomersRoutesI18n {
    public static readonly Aging = 'Aging';
    public static readonly AgingByCustomer = 'Aging By Customer';
    public static readonly Collections = 'Collections';
    public static readonly CollectionsByCustomer = 'Collections By Customer';
    public static readonly CustomerOverview = 'Customer Overview';
    public static readonly Customers = 'Customers';
    public static readonly Ineligibles = 'Ineligibles';
    public static readonly IneligiblesByCustomer = 'Ineligibles By Customer';
    public static readonly Overview = 'Overview';
    public static readonly Purchases = 'Purchases';
    public static readonly PurchasesByCustomer = 'Purchases By Customer';
    public static readonly RequestNewCustomerCredit = 'Request New Customer Credit';
}
